<template>
  <div class="container-table-app-vertical">
    <q-card>
      <q-card-section>
        <div class="row">
          <span class="title">Verticales de este Ámbito</span>
        </div>
        <q-table
          data-cy="verticales-table"
          :data="data"
          :columns="columns"
          row-key="id"
          selection="multiple"
          :selected.sync="selected"
          :loading="isLoadingVerticals"
          :pagination.sync="pagination"
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr
              :props="props"
              @click="setSelected(props)"
              style="cursor: pointer"
            >
              <q-td key="icon" :props="props">
                <div style="width: 24px; height: 24px">
                  <q-img
                    :src="
                      props.row.icon
                        ? props.row.icon
                        : require('@/assets/img/logo-dinapsis-aplicaciones.svg')
                    "
                    contain
                    width="24px"
                    height="24px"
                  />
                </div>
              </q-td>
              <q-td key="name" :props="props">
                {{ props.row.name }}
              </q-td>
              <q-td key="estado" :props="props">
                <q-toggle color="primary" v-model="props.selected" />
              </q-td>
              <q-td key="displayOrder" :props="props">
                {{ props.row.displayOrder ? props.row.displayOrder : 0 }}
              </q-td>
              <q-td key="visible" :props="props">
                <q-toggle
                  color="primary"
                  v-model="props.row.visible"
                  @input="saveVisible(props.row.visible, props.row)"
                />
              </q-td>
              <q-td key="editar" :props="props">
                <q-icon
                  data-cy="editVertical"
                  name="o_create"
                  style="color: rgba(0, 0, 0, 0.54); font-size: 24px"
                  @click="triggerEdit(props.row)"
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import Message from '@/components/shared/mixins/Message.js';
import Formats from '@/components/shared/mixins/Formats.js';
import Resources from '@/components/shared/mixins/Resources.js';

import {
  QToggle,
  QTable,
  QTd,
  QTr,
  QTh,
  QCard,
  QCardSection,
  QImg
} from 'quasar';

export default {
  components: {
    QToggle,
    QTable,
    QTd,
    QTr,
    QTh,
    QCard,
    QCardSection,
    QImg
  },
  mixins: [Message, Formats, Resources],
  props: {
    dataAmbito: Object,
    verticalSuper: Array,
    arrayVertical: Array,
    isLoadingVerticals: Boolean,
    isNew: Boolean
  },
  mounted () {
    this.$eventHub.$on('EJECUCION_GUARDAR_VERTICALES', ({ callback }) =>
      this.saveValue(callback)
    );
  },
  beforeDestroy () {
    this.$eventHub.$off('EJECUCION_GUARDAR_VERTICALES');
  },
  computed: {},
  data () {
    return {
      pagination: {
        sortBy: 'displayOrder',
        descending: false,
        rowsPerPage: 20
      },
      filter: '',
      columns: [
        {
          name: 'icon',
          label: 'Icono',
          align: 'left',
          field: 'icon',
          sortable: true
        },
        {
          name: 'name',
          label: 'Nombre del vertical',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'estado',
          label: 'Asignado a este Ámbito',
          align: 'left',
          field: '',
          sortable: true
        },
        {
          name: 'displayOrder',
          label: 'Orden',
          align: 'left',
          field: 'displayOrder',
          sortable: true
        },
        {
          name: 'visible',
          label: 'Visible',
          align: 'left',
          field: 'visible',
          sortable: true
        },
        {
          name: 'editar',
          label: 'Editar',
          align: 'left',
          field: '',
          sortable: false
        }
      ],
      data: this.verticalSuper,
      verticals: [],
      selected: [],
      ambito: null
    };
  },
  methods: {
    setSelected (d) {
      d.selected = !d.selected;
      return d;
    },
    triggerEdit (row) {
      let id = row.id;
      this.$router.push({
        name: 'form_edit_vertical',
        params: { idVertical: id }
      });
    },
    async saveVisible (value, row) {
      let dataArray = {
        name: row.name,
        visible: value,
        displayOrder: row.displayOrder
      };

      let request = {
        controller: '/Vertical/' + row.id,
        filter: {},
        body: dataArray
      };

      await this.$store
        .dispatch('PF/putSuit', request)
        .then((response) => {})
        .catch((err) => {
          this.showError(err);
        });
    },
    async saveValue (callback) {
      let apps = this.selected.map((n) => n.id);

      let dataArray = apps;

      let request = {
        controller:
          '/Ambito/' + this.dataAmbito.id + '/vertical-relationship',
        filter: {},
        body: dataArray
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/postSuit', request)
        .then((response) => {
          responseData = {
            data: response.data,
            status: true
          };

          callback(responseData);
        })
        .catch((err) => {
          this.showError(err);

          responseData = {
            data: null,
            status: false
          };

          callback(responseData);
        });
    }
  },
  watch: {
    verticalSuper: {
      handler: function () {
        this.verticals = this.verticalSuper === undefined ? {} : this.verticalSuper;
        if (Object.entries(this.verticalSuper).length > 0) {
          this.selected = this.verticals.map((n) => ({
            id: n.id
          }));
        }
      },
      immediate: true
    },
    arrayVertical: {
      handler: function () {
        this.data = this.arrayVertical;
        if (Object.entries(this.arrayVertical).length > 0) {
          // Set Resources to Vertical Array
          this.data.forEach(e => {
            let res = this.searchResource(e.resources, 'Logotipo');
            res !== null ? e.icon = res.url : e.icon = res;
          });
        }
      },
      immediate: true
    },
    dataAmbito: {
      handler: function () {
        this.ambito = this.dataAmbito;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-table-app-vertical {
  &:deep() {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }

    .q-expansion-item__toggle-icon--rotated {
      transform: rotate(-90deg);
    }
  }
}
</style>
